import angular from 'angular';
import utils from '../utils';

const __module__ = 'leiApp.services',
  app = angular.module(__module__, [utils]),
  { factory, config } = app;

export { app, factory, config, __module__ as default };
